import { FormInfoci } from "../../components/FormInfoci";

export const FormUser = () => {
  return (
    <>
      <FormInfoci/>
    </>
  );

}